import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[match]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MatchValidatorDirective,
        multi: true
    }]
})
export class MatchValidatorDirective implements Validator {
    @Input() match: string;

    validate(control: AbstractControl): {[key: string]: any} {
        return fieldsMatchValidatorFn(
            (control.value),
            (control.root.get(this.match) ? control.root.get(this.match).value : '')
        );
    }
}
export function fieldsMatchValidatorFn(value: string, valueToMatch: string) {
    return (value !== valueToMatch
        ? {'match': true} : null
    );
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/validators/match.directive.ts